<template>
    <div class="content">
        <div class="content_wrap">
            <h2 class="content_title">Summary</h2>
            
            <div class="slide_wrap">
                <div class="summary_head clearfix">
                    <div class="summary_title float_left clearfix">
                        <img :src="'../assets/images/summarytitle.png'" alt="Summary" class="float_left">
                        <p class="float_left">이번시간에 학습한 내용을 정리해 보세요.</p>
                    </div>
                    <ul class="summary_btn float_right clearfix">
                        <li class="float_left">
                            <a  v-if="contents.currentSlide != null && contents.currentSlide.hasOwnProperty('print') && contents.currentSlide.print == true"
                            href="#" @click="print()" class="printbt">프린트</a>
                        </li>
                        <li class="float_left">
                            <a v-if="contents.currentSlide != null && contents.currentSlide.hasOwnProperty('download')"
                                @click="downloadHandler()" href="#" class="savebt">저장하기</a>
                        </li>
                    </ul>
                </div>
                <div class="bxslider">
                    <!-- 반복되는 slide -->
                    <div class="slide_cont summary" v-for="slide in contents.currentSlide.slides"> 
                        <div class="slider" v-html="slide.body"></div>
                    </div>
                    <!-- 반복되는 slide 끝-->
                </div>
            </div>
        </div>
        <audio v-if="contents.currentSlide.bgm != undefined" ref="currentAudio">
            <source :src="'../assets/media/' + contents.currentSlide.bgm" type="audio/mpeg">
        </audio>
    </div>
</template>
<script>
export default {
    props : ['contents'],
    data(){
        return{
            list : []
        }
    },
    methods:{
        print(){
            window.print();
        },
		downloadHandler(){
			window.open("./data/" + this.contents.currentSlide.download);
		}
    },
     mounted(){
        setTimeout(()=>{
            this.$refs.currentAudio.play()
        }, 1000);
    }
}
</script>